import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Severity } from '../../components/common/FlashSnackbar';

type FlashPayload = { severity: Severity; msg: string };
type FlashState = { flash?: FlashPayload };

export function useFlashFromLocation() {
  const navigate = useNavigate();
  const location = useLocation() as unknown as {
    state?: FlashState;
    pathname: string;
    key: string;
  };

  const flash = location.state?.flash;
  const [open, setOpen] = useState<boolean>(!!flash);
  const [msg, setMsg] = useState<string>(flash?.msg ?? '');
  const [severity, setSeverity] = useState<Severity>(
    flash?.severity ?? 'success'
  );

  const [consumedAt, setConsumedAt] = useState<number | null>(null);

  useEffect(() => {
    if (flash) {
      setOpen(true);
      setMsg(flash.msg);
      setSeverity(flash.severity);
      setConsumedAt(Date.now());

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [flash, location.key, location.pathname, navigate]);

  const handleClose = () => {
    setOpen(false);
    setMsg('');
  };

  return { open, msg, severity, handleClose, consumedAt };
}
